import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Floor } from 'entities/Floor';

interface UseSelectedFloorParams {
  floors: Floor[] | undefined;
  selectedBoxId: string | undefined;
  selectedBoxFloorId: string | undefined;
}

interface UseSelectedFloorApi {
  selectedFloor: Nullable<string>;
  setSelectedFloor: Dispatch<SetStateAction<Nullable<string>>>;
}

export const useSelectedFloor = (params: UseSelectedFloorParams): UseSelectedFloorApi => {
  const { floors, selectedBoxId, selectedBoxFloorId } = params;

  const [selectedFloor, setSelectedFloor] = useState<Nullable<string>>(null);

  useEffect(() => {
    if (!floors?.length) {
      return;
    }

    if (selectedBoxId && selectedBoxFloorId && floors.some((floor) => floor.floorId === selectedBoxFloorId)) {
      setSelectedFloor(selectedBoxFloorId);

      return;
    }

    setSelectedFloor((prev) => (prev && floors.some((floor) => floor.floorId === prev) ? prev : floors[0].floorId));
  }, [floors, selectedBoxFloorId, selectedBoxId]);

  return { selectedFloor, setSelectedFloor };
};
